import {library} from '@fortawesome/fontawesome-svg-core';

import {
  faAngleLeft,
  faAngleRight,
  faArrowsSpin,
  faBarsStaggered,
  faBuilding,
  faCheck,
  faCheckCircle,
  faCircleNotch,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faCode,
  faCoins,
  faCopy,
  faDatabase,
  faDolly,
  faEdit,
  faEnvelope,
  faEthernet,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileCircleQuestion,
  faFileInvoice,
  faFilter,
  faGlobe,
  faGlobeEurope,
  faHandPointRight,
  faHandshake,
  faHandshakeAngle,
  faHome,
  faHourglassHalf,
  faInfoCircle,
  faKey,
  faLifeRing,
  faLightbulb,
  faLink,
  faList,
  faMapMarkerAlt,
  faMessage,
  faMoneyCheck,
  faNetworkWired,
  faPiggyBank,
  faPlay,
  faPlugCircleBolt,
  faPlugCircleCheck,
  faPlugCircleXmark,
  faPlus,
  faPowerOff,
  faQuestionCircle,
  faRandom,
  faRedo,
  faRoute,
  faSave,
  faSearch,
  faServer,
  faShop,
  faShoppingCart,
  faSignal,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faStopwatch,
  faStream,
  faTh,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faTv,
  faUser,
  faUserCheck,
  faUserCog,
  faUsers,
  faUserShield,
  faUserTie,
  faUserXmark,
  faVirus,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowsSpin,
  faBarsStaggered,
  faBuilding,
  faCheck,
  faCheckCircle,
  faCode,
  faCoins,
  faCopy,
  faCircleNotch,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faDatabase,
  faDolly,
  faEdit,
  faEnvelope,
  faEthernet,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileCircleQuestion,
  faFileInvoice,
  faFilter,
  faGlobe,
  faGlobeEurope,
  faHandPointRight,
  faHandshake,
  faHandshakeAngle,
  faHome,
  faHourglassHalf,
  faInfoCircle,
  faKey,
  faLifeRing,
  faLightbulb,
  faLink,
  faList,
  faMapMarkerAlt,
  faMessage,
  faMoneyCheck,
  faNetworkWired,
  faPiggyBank,
  faPlay,
  faPlugCircleBolt,
  faPlugCircleCheck,
  faPlugCircleXmark,
  faPlus,
  faPowerOff,
  faQuestionCircle,
  faRandom,
  faRedo,
  faRoute,
  faSave,
  faSearch,
  faServer,
  faSignal,
  faSort,
  faSortDown,
  faSortUp,
  faStream,
  faShop,
  faShoppingCart,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faStopwatch,
  faTh,
  faTimes,
  faTimesCircle,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faTv,
  faUser,
  faUserCheck,
  faUserCog,
  faUsers,
  faUserShield,
  faUserTie,
  faUserXmark,
  faVirus,
);
